/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../helpers'
import { Hotel } from '../../../../app/pages/hotel-management/hotel-list/core/_models'

type Props = {
  hotel: Hotel
}

const HotelInfoCell: FC<Props> = ({hotel}) => (
  <div className='d-flex align-items-center'>
    {/* begin:: Avatar */}
    <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
       {/*<a href='#'>
        {hotel.image ? (
          <div className='symbol-label'>
            <img src={toAbsoluteUrl(`${hotel.image}`)} alt={hotel.image} className='w-100' />
          </div>
        ) : (
        <></>
        )}
      </a>
      */}
    </div>
    <div className='symbol symbol-circle symbol-50px overflow-hidden '>
    
    </div>
    <div className='d-flex flex-column'>
      <span className='text-gray-800  mb-1'>
        {hotel?.name}
      </span>
    </div>
 
  </div>
)

export {HotelInfoCell}
